import classNames from 'classnames';
import { FC, KeyboardEvent, ReactNode } from 'react';

export const WithInputGroupAppend: FC<{
  children: ReactNode;
  addOn?: ReactNode;
  className?: string;
  onKeyDown?: (e: KeyboardEvent) => void;
  isFocused?: boolean;
}> = ({ children, addOn, className, onKeyDown }) => {
  return (
    <div className="input-group">
      {children}
      {addOn && (
        <div onKeyDown={onKeyDown} key="input" className={classNames('input-group-text', className)}>
          {addOn}
        </div>
      )}
    </div>
  );
};
